!function(window, document) {

    'use strict';


    class SsoAdManager {
        static supportedScripts = [
            {key: 'sall', vendor: sso.consent.vendorList.SeedingAlliance},
            {key: 'conative', vendor: sso.consent.vendorList.DefineMedia},
        ];

        static load() {
            this._decideSallConativeSlot();
            this._loadScripts();
        }

        static _loadScripts() {
            this.supportedScripts
                .filter(({key}) => !!document.querySelector(`[data-ads-requires-script=${key}]`))
                .forEach(({key, vendor}) => {
                    const scriptTemplate = document.querySelector(`template[data-ads-provides-script=${key}]`);
                    if (!scriptTemplate) {
                        console.log('%cSCRIPTLOADER: ', 'background: #a9007a; color: white;', 'no provider found', key);
                        return;
                    }

                    sso.consent.dependsOn(vendor, () => {
                        document.head.append(scriptTemplate.content.cloneNode(true));
                        scriptTemplate.remove();
                        console.log('%cSCRIPTLOADER: ', 'background: #a9007a; color: white;', 'loading script', key);
                    });

                });
        }

        static _decideSallConativeSlot() {
            const container = document.querySelector('div[data-ads-provider=sso][data-ads-slot=sall_conative]');
            if (!container) return;
            const threshold = window.sso.init.deviceIsMobile
                ? window.sso.init?.adsConfig?.ads?.tests?.SeedingAlliance_Conative?.nativendoShareMobile
                : window.sso.init?.adsConfig?.ads?.tests?.SeedingAlliance_Conative?.nativendoShareDesktop;
            if (threshold === undefined) {
                console.log('%cSALL/C: ', 'background: red; color: white;', 'missing config');
                return;
            }

            const diceChoice = Math.random();
            const choice = threshold && diceChoice <= threshold ? 'sall' : 'conative';

            /** @type HTMLTemplateElement */
            const template = container.querySelector(`template[data-choice=${choice}]`);
            if (template) {
                container.dataset.choice = `${choice}/${threshold}/${diceChoice}`;
                container.textContent = '';
                container.appendChild(template.content.cloneNode(true));
            }
        }
    }


    class GlobalAdManager {
        /**
         * @param {string} sdgZone
         * @param {{loadTransitionAds: boolean, blockFormats?: string[]}?} options
         */
        initSDG (sdgZone, options) {
            console.log('%cInitialising SDG...', 'background: #a9007a; color: white;');
            SDG.Publisher.setZone(sdgZone);
            if (options?.loadTransitionAds === true) {
                SDG.Publisher.transitionAdvertisements();
            }
            this._loadAllSlots(false, options?.blockFormats);
            SDG.Publisher.finalizeSlots();

            console.log('%cSDG initialized.', 'background: #a9007a; color: white;');
            this._logPerformanceMarker();
        }

        initSsoSlots() {
            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', () => SsoAdManager.load());
                return;
            } else {
                SsoAdManager.load();
            }
        }

        initRotation() {
            const manager = new RotationManager();
            manager.setup();
        }

        /**
         * @param {string} sdgZone
         * @param {{loadTransitionAds: boolean, blockFormats?: string[]}?} options
         */
        initSDGAsync (sdgZone, options) {
            console.log('%cInitialising SDG...', 'background: #a9007a; color: white;');
            window.SDG = window.SDG || {};
            window.SDG.cmd = window.SDG.cmd || [];
            window.SDG.cmd.push(() => SDG.Publisher.setZone(sdgZone));
            if (options?.loadTransitionAds === true) {
                window.SDG.cmd.push(() => SDG.Publisher.transitionAdvertisements());
            }
            this._loadAllSlots(true, options?.blockFormats);
            window.SDG.cmd.push(() => SDG.Publisher.finalizeSlots());

            console.log('%cSDG initialized.', 'background: #a9007a; color: white;');
            window.SDG.cmd.push(() => this._logPerformanceMarker());
        }

        _loadAllSlots (register_async = false, blockFormats) {
            blockFormats = !!blockFormats && Array.isArray(blockFormats) ? blockFormats : null;
            document.querySelectorAll('[data-ads-provider=sdg]').forEach((node) => {
                const slotName = node.dataset.adsSlot;
                this._setContainerId(slotName, node);
                if (register_async) {
                    console.log('%cSLOTMANAGER: ', 'background: #a9007a; color: white;', 'found', slotName);
                    window.SDG.cmd.push(() => this._loadSlot(slotName, node));
                } else {
                    this._loadSlot(slotName, node, blockFormats);
                }
             });
        }

        _loadSlot(slotName, node, blockFormats) {
            const sdgSlot = SDG.Publisher.registerSlot(slotName, node);
            let loggingData = this._configureSlot(sdgSlot, node);

            if (!!blockFormats) {
                sdgSlot.blockFormats(blockFormats);
                if (!loggingData) loggingData = [];
                loggingData.push('blocked:' + blockFormats.join(','))
            }

            if (node.dataset.adsViewportLoad === 'false') {  // false is the default case; true is special here
                sdgSlot.load();
                console.log('%cSLOTMANAGER: ', 'background: #a9007a; color: white;', 'load', slotName, loggingData ?? '');
            } else {
                this._customSlotLogic(slotName, sdgSlot, node)
                console.log('%cSLOTMANAGER: ', 'background: #a9007a; color: white;', 'custom load', slotName, loggingData ?? '');
            }
        }

        _configureSlot(sdgSlot, node) {
            const loggingData = [];
            if (node.dataset?.adsSetSticky === 'true') {
                sdgSlot.configure({pinToBottom: true});
                loggingData.push('sticky');
            }
            const reserveSpace = node.dataset?.adsReserveSpace ?? 'false';
            if (reserveSpace === 'true' || /^[0-9]+$/.test(reserveSpace)) {
                // NOTE: if either literal 'true' or a number (of pixels)
                sdgSlot.configure({
                    showLoadingAnimation: true,
                    reserveSpace: true,
                });
                loggingData.push('reserve');
                if (reserveSpace !== 'true') {
                    // i.e., it's a number in string format
                    sdgSlot.configure({
                        fixedHeight: +reserveSpace,
                    });
                }
            }
            return loggingData.length ? loggingData : null;
        }

        _customSlotLogic(slotName, sdgSlot, node) { }

        _setContainerId (slotName, node) {
            if (!node.id) {
                const idName = 'id_sdg_slot_' + slotName;
                const idCount = document.querySelectorAll(`*[id^=${idName}]`).length;
                node.id = idCount === 0 ? idName : `${idName}_${idCount + 1}`;
            }
        }

        _logPerformanceMarker() {
            try {
                performance.mark('sso-metatag-init-done');
                const metatag = this._measure('sso-pre-scripts', 'sso-metatag-init-done', 'sso-m-metatag');
                const sp_user = this._measure('sso-pre-scripts', 'sso-sp-done-user', 'sso-m-sp-user');
                const sp_loaded = this._measure('sso-pre-scripts', 'sso-sp-done-loaded', 'sso-m-sp-loaded');
                const cp = this._measure('sso-pre-scripts', 'sso-cp-done', 'sso-m-cp');
                const measurements = [metatag, sp_loaded, sp_user, cp];
                sso_analytics.proxyEvent({
                    eventCategory: 'adstack',
                    eventAction: 'performance',
                    eventLabel: measurements.map((m) => Math.round(m)).join(','),
                    nonInteraction: true,
                });
                console.log('%cMEASUREMENT: ', 'background: #4caf50; color: white;', measurements.map((m) => Math.round(m)).join(','));
            } catch (e) {}
        }

        /**
         * Measures between two performance markers. Returns zero duration if marker doesn't exist.
         * @param fromMark
         * @param toMark
         * @param measurementName
         * @return {number}
         * @private
         */
        _measure(fromMark, toMark, measurementName) {
            return performance.getEntriesByName(fromMark, 'mark').length > 0 && performance.getEntriesByName(toMark, 'mark').length > 0
                    ? performance.measure(measurementName, fromMark, toMark).duration
                    : 0;
        }

        static getAllSlotContainers() {
            return document.querySelectorAll('[data-ads-provider=sdg]');
        }

        static initAmazonPreBidSystem () {
            (function (a9, a, p, s, t, A, g) {
                if (a[a9]) return; function q(c, r) { a[a9]._Q.push([c, r]) }a[a9] = {init: function () { q('i', arguments) }, fetchBids: function () { q('f', arguments) }, setDisplayBids: function () {}, targetingKeys: function () { return [] }, _Q: []}; A = p.createElement(s); A.async = !0; A.src = t; g = p.getElementsByTagName(s)[0]; g.parentNode.insertBefore(A, g)
            }('apstag', window, document, 'script', '//c.amazon-adsystem.com/aax2/apstag.js'));
        }
    }

    class Status {
        static free = 'free';
        static blocked = 'blocked';
        static loaded = 'loaded';
        static optional = 'optional';
        static initializing = 'initializing';
    }

    class Slot {
        name;
        status;
        node;
        _timeout;
        _nextStatus;

        constructor(name, status = Status.free, node = null) {
            this.name = name;
            this.status = status;
            this.node = node;
        }

        setStatus(status, after = 0) {
            if (after) {
                // With timeout; clear old and register timeout to set next status
                if (this._timeout) clearTimeout(this._timeout);
                this.status = Status.blocked;
                this._nextStatus = status;
                this._timeout = setTimeout(
                    () => {
                        this._timeout = null;
                        this.setStatus(this._nextStatus);
                    },
                    after,
                );
            } else if (this._timeout) {
                // If timout is still running and shall not be replaced change the final status
                this._nextStatus = status;
            } else {
                // No timeout; actually set status; "optional" status shall trigger check for waiting container
                this.status = status;
                if (status === Status.optional) {
                    document.dispatchEvent(checkWaitingEvent);
                }
            }
        }

        loadAd(node) {
            // This blocks the slot and sets it to free again if anything fails while loading
            this.setStatus(Status.free, 5000);

            const minSlotHeight = this.name === 'topmobile2' ? 600 : 250;
            const sdgSlot = SDG.Publisher.registerSlot(this.name, node);
            if (sdgSlot) {
                sdgSlot.configure({
                    showAdvertLabel: false,
                    centerAds: true,
                    showLoadingAnimation: true,
                    lazyLoad: false,
                    scrollInContainer: true,
                    reserveSpace: true,
                    fixedHeight: minSlotHeight,
                });
                sdgSlot.load();
                console.debug('%cRotation: SDG loaded', 'background: #d4c28e; color: #333', this.name);
            }

            this.node = node;
            this.node.dataset.adsSlot = this.name;
            this.updateHeightRequirement(minSlotHeight);
            this.setStatus(Status.loaded, 5000);
        }

        unloadAd() {
            this.preserveHeight();

            SDG.Publisher.unregisterSlot(this.name, true);
            console.debug('%cRotation: SDG removed', 'background: #d4c28e; color: #333', this.name);

            delete this.node.dataset.adsSlot;
            this.node = null;
            this.setStatus(Status.free);
        }

        transferAdSlotTo(node) {
            if (this.status === Status.optional) {
                this.unloadAd();
            }
            this.loadAd(node);
        }

        preserveHeight() {
            this.updateHeightRequirement();
        }

        updateHeightRequirement(minimumHeight = 0) {
            const absoluteMinimum = 250;
            const nodeHeight = this.node.clientHeight;
            let storedHeight = parseInt(this.node.dataset?.minHeight);
            storedHeight = isNaN(storedHeight) ? 0 : storedHeight;
            const newMinimumHeight = Math.max(nodeHeight, storedHeight, minimumHeight, absoluteMinimum);

            this.node.dataset.minHeight = `${newMinimumHeight}`;
            this.node.style.minHeight = `${newMinimumHeight}px`;
        }
    }

    class RotationManager {
        rotationSlots = ['topmobile2', 'topmobile3', 'topmobile4', 'topmobile5']
        managedSlots = new Map();
        containerWaitingForFreeAdSlot = new Set();

        getContainerToObserve() {
            const container = {registered: [], free: []};
            // Find all SDG defined slots
            document.querySelectorAll('.da-container [data-ads-provider=sdg][data-ads-slot]').forEach((node) => {
                if (!this.rotationSlots.includes(node?.dataset?.adsSlot)) return;
                container.registered.push(node);
            });
            // Add all placeholder
            document.querySelectorAll('.da-container [data-ads-provider=placeholder]').forEach((node) => {
                container.free.push(node);
            });
            return container;
        }

        setup() {
            this.rotationSlots.forEach((slotName) => this.managedSlots.set(slotName, new Slot(slotName)));
            const container = this.getContainerToObserve();
            // Set up registered SDG slots
            container.registered.forEach((node) => {
                const slotName = node.dataset.adsSlot;
                this.managedSlots.set(slotName, new Slot(slotName, Status.initializing, node));
            });

            this.start([...container.registered, ...container.free]);

            document.addEventListener(checkWaitingEvent.type, () => this.resolveWaitingContainerIfAvailableSlot());
        }

        start(containerToObserve) {
            const observer = new IntersectionObserver(
                this.intersectionCallback.bind(this),
                {
                    rootMargin: '400px',
                },
            );
            containerToObserve.forEach((node) => observer.observe(node));
        }

        findAvailableSlot() {
            const slots = [...this.managedSlots.values()];
            // Free slots should always have priority
            const freeSlot = slots.find((slot) => slot.status === Status.free);
            if (freeSlot) return freeSlot;
            // Find optional slot furthest from the viewport
            // Without distance the container order would cause `array.find()` to rotate same two slots.
            return slots
                .filter((slot) => slot.status === Status.optional)
                .sort((slot1, slot2) => this.distanceFromViewport(slot1.node) - this.distanceFromViewport(slot2.node))
                .pop();
        }

        distanceFromViewport(node) {
            const nodeBounds = node.getBoundingClientRect();
            const windowHeight = window.innerHeight;
            // Above viewport; ensure positive distance
            if (nodeBounds.bottom < 0) {
                return Math.abs(nodeBounds.bottom);
            }
            // Below viewport
            if (nodeBounds.top > windowHeight) {
                return nodeBounds.top - windowHeight;
            }
            // In viewport
            return 0;
        }

        resolveWaitingContainerIfAvailableSlot() {
            this.containerWaitingForFreeAdSlot.forEach((container) => {
                const availableSlot = this.findAvailableSlot();
                if (availableSlot) {
                    this.containerWaitingForFreeAdSlot.delete(container);
                    availableSlot.transferAdSlotTo(container);
                }
            })
        }

        intersectionCallback(entries, _observer) {
            entries.forEach((entry) => {
                const container = entry.target;
                const isIntersecting = entry.isIntersecting;
                const slot = this.managedSlots.get(container?.dataset?.adsSlot);

                if (slot?.status === Status.initializing) {
                    if (isIntersecting) {
                        slot.setStatus(Status.loaded, 5000);
                    }
                } else if (slot) {
                    // Managed slot gets moved in/out of viewport --> update status only
                    slot.setStatus(isIntersecting ? Status.loaded : Status.optional);
                } else if (isIntersecting) {
                    // Free slot moves into viewport --> needs slot
                    const availableSlot = this.findAvailableSlot();
                    if (availableSlot) {
                        availableSlot.transferAdSlotTo(container);
                    } else {
                        this.containerWaitingForFreeAdSlot.add(container);
                    }
                } else {
                    // Free slot moves out of viewport --> stop potential wait
                    this.containerWaitingForFreeAdSlot.delete(container);
                }
            });
        }
    }

    const checkWaitingEvent = new Event('sso-check-waiting');

    window.sso.GlobalAdManager = GlobalAdManager;
}(window, document);
